import React, { useState, useRef, useMemo, useEffect } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
}) => {
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  // 需要登入嗎
  const requiresLogin = {
    login: false,
    title: '員工編號（邁達特：MA、啟迪：GI、聚上雲：EP、逐鹿：GU）',
    placeholder: 'MA00000',
    alert: '員工編號有誤，請重新登入，謝謝',
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  const canShowPrevButtonPages = null
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})
  const bringOptionsMapRef = useRef({})
  // 防止閃閃
  useEffect(() => {
    const timeout = setTimeout(() => {
      const isMobile = window.innerWidth <= 576
      if (!isMobile) return

      const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            const rootEl = document.querySelector('.sd-root-modern')
            if (
              rootEl &&
              !rootEl.classList.contains('sd-root-modern--mobile')
            ) {
              rootEl.classList.add('sd-root-modern--mobile')
              console.log('✅ 強制加上 mobile class 避免抖動')
            }
          }
        }
      })

      observer.observe(document.getElementById('root'), {
        childList: true,
        subtree: true,
      })

      // 清除
      return () => observer.disconnect()
    }, 100) // 100ms 後再判斷

    return () => clearTimeout(timeout)
  }, [])
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(30)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }

  const visibleIfConditionsInit = {
    q3: '{q2} = 1',
    q4: '{q2} = 1',
    q5: '{q2} = 1',
    q6: '{q2} = 2',

    q9: '{q8} anyof [0]',
    q10: '{q8} anyof [1]',
    q11: '{q8} anyof [2]',
    q12: '{q8} anyof ["other"]',

    // 特殊矩陣
    q14: '{q13.0} = 1 or {q13.1} = 1 or {q13.2} = 1 or {q13.3} = 1 or {q13.4} = 1 or {q13.5} = 1 or {q13.6} = 1 or {q13.7} = 1 or {q13.8} = 1 or {q13.9} = 1',
    'q14.row0': '{q13.0} = 1',
    'q14.row1': '{q13.1} = 1',
    'q14.row2': '{q13.2} = 1',
    'q14.row3': '{q13.3} = 1',
    'q14.row4': '{q13.4} = 1',
    'q14.row5': '{q13.5} = 1',
    'q14.row6': '{q13.6} = 1',
    'q14.row7': '{q13.7} = 1',
    'q14.row8': '{q13.8} = 1',
    'q14.row9': '{q13.9} = 1',
    q15: '({q13.0} = 1 or {q13.1} = 1 or {q13.2} = 1 or {q13.3} = 1 or {q13.4} = 1 or {q13.5} = 1 or {q13.6} = 1 or {q13.7} = 1 or {q13.8} = 1 or {q13.9} = 1) and ({q14.0} = 0 or {q14.1} = 0 or {q14.2} = 0 or {q14.3} = 0 or {q14.4} = 0 or {q14.5} = 0 or {q14.6} = 0 or {q14.7} = 0 or {q14.8} = 0 or {q14.9} = 0)',
    'q15.row0': '{q13.0} = 1 and {q14.0} = 0',
    'q15.row1': '{q13.1} = 1 and {q14.1} = 0',
    'q15.row2': '{q13.2} = 1 and {q14.2} = 0',
    'q15.row3': '{q13.3} = 1 and {q14.3} = 0',
    'q15.row4': '{q13.4} = 1 and {q14.4} = 0',
    'q15.row5': '{q13.5} = 1 and {q14.5} = 0',
    'q15.row6': '{q13.6} = 1 and {q14.6} = 0',
    'q15.row7': '{q13.7} = 1 and {q14.7} = 0',
    'q15.row8': '{q13.8} = 1 and {q14.8} = 0',
    'q15.row9': '{q13.9} = 1 and {q14.9} = 0',
    q16: '({q13.0} = 1 or {q13.1} = 1 or {q13.2} = 1 or {q13.3} = 1 or {q13.4} = 1 or {q13.5} = 1 or {q13.6} = 1 or {q13.7} = 1 or {q13.8} = 1 or {q13.9} = 1) and ({q14.0} = 1 or {q14.1} = 1 or {q14.2} = 1 or {q14.3} = 1 or {q14.4} = 1 or {q14.5} = 1 or {q14.6} = 1 or {q14.7} = 1 or {q14.8} = 1 or {q14.9} = 1)',
    'q16.row0': '{q13.0} = 1 and {q14.0} = 1',
    'q16.row1': '{q13.1} = 1 and {q14.1} = 1',
    'q16.row2': '{q13.2} = 1 and {q14.2} = 1',
    'q16.row3': '{q13.3} = 1 and {q14.3} = 1',
    'q16.row4': '{q13.4} = 1 and {q14.4} = 1',
    'q16.row5': '{q13.5} = 1 and {q14.5} = 1',
    'q16.row6': '{q13.6} = 1 and {q14.6} = 1',
    'q16.row7': '{q13.7} = 1 and {q14.7} = 1',
    'q16.row8': '{q13.8} = 1 and {q14.8} = 1',
    'q16.row9': '{q13.9} = 1 and {q14.9} = 1',

    q18: '{q17} = 0 or {q17} = 1 or {q17} = 2 or {q17} = 3 or {q17} = 4',
    q19: '{q17} = 0 or {q17} = 1 or {q17} = 2 or {q17} = 3 or {q17} = 4',
    q20: '{q17} = 0 or {q17} = 1 or {q17} = 2 or {q17} = 3 or {q17} = 4',

    q22: '{q21} = 0 or {q21} = 1 or {q21} = 2 or {q21} = 3 or {q21} = 4 or {q21} = 5',
    q23: '{q21} = 0 or {q21} = 1 or {q21} = 2 or {q21} = 3 or {q21} = 4 or {q21} = 5',
    q24: '({q21} = 0 or {q21} = 1 or {q21} = 2 or {q21} = 3 or {q21} = 4 or {q21} = 5) and ({q23} = 0)',
    q25: '({q21} = 0 or {q21} = 1 or {q21} = 2 or {q21} = 3 or {q21} = 4 or {q21} = 5) and ({q23} = 0)',
    q26: '({q21} = 0 or {q21} = 1 or {q21} = 2 or {q21} = 3 or {q21} = 4 or {q21} = 5) and ({q23} = 0)',
    q27: '({q21} = 0 or {q21} = 1 or {q21} = 2 or {q21} = 3 or {q21} = 4 or {q21} = 5) and ({q23} = 0)',
    q28: '{q21} = 0 or {q21} = 1 or {q21} = 2 or {q21} = 3 or {q21} = 4 or {q21} = 5',
    // 待淑方補 q29({q28} = "other")
    q29: '({q21} = 0 or {q21} = 1 or {q21} = 2 or {q21} = 3 or {q21} = 4 or {q21} = 5) and {q28} = "other"',
    q30: '({q21} = 0 or {q21} = 1 or {q21} = 2 or {q21} = 3 or {q21} = 4 or {q21} = 5) and {q28} = "other"',
    q31: '({q21} = 0 or {q21} = 1 or {q21} = 2 or {q21} = 3 or {q21} = 4 or {q21} = 5)',
    q32: '({q21} = 0 or {q21} = 1 or {q21} = 2 or {q21} = 3 or {q21} = 4 or {q21} = 5) and {q31} = "other"',
    q33: '({q21} = 0 or {q21} = 1 or {q21} = 2 or {q21} = 3 or {q21} = 4 or {q21} = 5) and {q31} = "other"',

    q60: '{q59} = 0',
    q61: '{q59} = 1 or {q59} = 2',
    q62: '{q59} = 3 or {q59} = 4 or {q59} = 5',

    // 待淑方補 q70/73
    q70: '{q69} = "other"',
    q71: '{q69} = "other"',
    q73: '{q72} = "other"',
    q74: '{q72} = "other"',

    q77: '{q76} = 1 or {q76} = 2',
    q78: '{q76} = 1 or {q76} = 2',
    q79: '{q76} = 1 or {q76} = 2',
    q80: '{q76} = 1 or {q76} = 2',
    q81: '{q76} = 1 or {q76} = 2',
    q82: '({q76} = 1 or {q76} = 2) and ({q81} = 0)',
    q83: '({q76} = 1 or {q76} = 2) and ({q81} = 1)',
    q84: '{q76} = 1 or {q76} = 2',
    q85: '{q76} = 1 or {q76} = 2',
    q86: '{q76} = 1 or {q76} = 2',
    q87: '{q76} = 1 or {q76} = 2',
    q88: '{q76} = 1 or {q76} = 2',

    q90: '{q89} = 0 or {q89} = 1',

    // 特殊矩陣
    q94: '{q93.0} = 0',
    q95: '{q93.1} = 0',
    q96: '{q93.2} = 0',
    q97: '{q93.3} = 0',
    q98: '{q93.0} = 1 or {q93.1} = 1 or {q93.2} = 1 or {q93.3} = 1',
    'q98.row0': '{q93.0} = 1',
    'q98.row1': '{q93.1} = 1',
    'q98.row2': '{q93.2} = 1',
    'q98.row3': '{q93.3} = 1',

    q114: '{q113} anyof [0, 1, 2, "other"]',
    q115: '{q113} anyof [0, 1, 2, "other"]',
    q116: '{q113} anyof [0, 1, 2, "other"]',
    q117: '{q113} anyof [0, 1, 2, "other"]',
    q118: '{q113} anyof [0, 1, 2, "other"]',

    q119: '({q113} anyof [0, 1, 2, "other"]) and ({q117.0} = 0 or {q117.0} = 1)',
    q120: '({q113} anyof [0, 1, 2, "other"]) and ({q117.1} = 0 or {q117.1} = 1)',
    q121: '({q113} anyof [0, 1, 2, "other"]) and ({q117.2} = 0 or {q117.2} = 1)',
    q122: '({q113} anyof [0, 1, 2, "other"]) and ({q117.3} = 0 or {q117.3} = 1) ',
    q123: '({q113} anyof [0, 1, 2, "other"]) and ({q117.4} = 0 or {q117.4} = 1)',
    q124: '({q113} anyof [0, 1, 2, "other"]) and ({q117.5} = 0 or {q117.5} = 1)',

    q126: '{q125} = 1',
  }
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [117.5]
  const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  const triggersConditionsInit = [
    {
      type: 'complete',
      expression: `({q0} = 1))`,
    },
  ]
  // const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null
  // 帶出: 帶入
  const questionMappings = {
    // q20: 'q21',
  }

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
    questionMappings,
    bringOptionsMapRef,
  })

  // const newSurvey = new Model(convertedSurvey)

  const surveyModel = useMemo(() => {
    if (!convertedSurvey) return null
    return new Model(convertedSurvey)
  }, [convertedSurvey])

  // 當 surveyModel 建立時，自動捲動到頂端
  useEffect(() => {
    if (surveyModel) {
      // 延遲執行以確保 DOM 已更新
      setTimeout(() => {
        // 捲動到頁面頂端
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant', // 平滑捲動，也可以使用 'instant' 立即跳到頂端
        })

        // 或者也可以嘗試捲動問卷容器本身
        const surveyContainer = document.querySelector('.sd-root-modern')
        if (surveyContainer) {
          surveyContainer.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }, 100) // 給 DOM 一點時間完成渲染
    }
  }, [surveyModel])

  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])

  const endMessage = `目前與您相同特性的樣本額滿，已停止收卷，可惜沒辦法繼續參與本次活動。如果覺得這個主題很有意思，非常歡迎您分享本問卷連結給親友，或是加入我們的<a href='https://lin.ee/HWETcqy'>LINE@</a>，隨時得到最新填問卷獲好禮的消息。<p>請按「完成」前往下載 EZChoice 或填寫更多問卷</p>`

  function helpFunction(survey, options) {
    // console.log('survey.getValue(q42)', survey.getValue('q42'))
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
  }

  const endSurveyMsg = (survey) => {
    if (survey.getValue('q0') === 1) {
      setCompletionMessage(endMessage)
    } else {
      setCompletionMessage(
        `<div>感謝您的填答～歡迎轉發分享！<br><br>想參加更多問卷調查活動？手指點點就可以抽獎賺好康！<br>點擊下方按鈕加入 EZChoice APP<br>或複製下載連結 <a href="https://ezcapp.page.link/tAQv" target="_blank">https://ezcapp.page.link/tAQv</a><br>裡面還有更多填問卷拿購物金的活動唷～<br>各種好玩的問卷等你來玩！<br><br>想知道更多好康問卷、活動消息，請追蹤關注<br><a href="https://www.facebook.com/EasyCTRs" target="_blank">【輕鬆點點】粉絲專頁</a><br><br>加入我們的 <a href="https://lin.ee/HWETcqy" target="_blank">LINE@</a>，<br>隨時得到最新填問卷獲好禮的消息。<br><br><h4 style="text-align: center">請按「完成」前往下載 EZChoice 或填寫更多問卷</h4></div>`
      )
    }
  }

  // useEffect(() => {
  //   console.log('bringOptionsMapRef', bringOptionsMapRef)
  // }, [bringOptionsMapRef])

  useSubmitAnswers({
    survey: surveyModel,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    endSurveyMsg,
    bringOptionsMapRef,
  })

  return (
    <>
      {surveyModel ? (
        <Survey model={surveyModel} key={pid} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
